import { ADObjectClass } from '@/sections/insights/queryBuilder/entities/adobjects/filters/ADObjectClass';
import type { SimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/types';

import { ADObjectACLProtected } from './filters/ADObjectACLProtected';
import { ADObjectAdminCount } from './filters/ADObjectAdminCount';
import { ADObjectAuthenticationEnabled } from './filters/ADObjectAuthenticationEnabled';
import { ADObjectCannotBeDelegated } from './filters/ADObjectCannotBeDelegated';
import { ADObjectDomain } from './filters/ADObjectDomain';
import { ADObjectHasSPN } from './filters/ADObjectHasSPN';
import { ADObjectIsDomainController } from './filters/ADObjectIsDomainController';
import { ADObjectObjectID } from './filters/ADObjectObjectID';
import { ADObjectPasswordExpired } from './filters/ADObjectPasswordExpired';
import { ADObjectPasswordNeverExpires } from './filters/ADObjectPasswordNeverExpires';
import { ADObjectPreAuthNotRequired } from './filters/ADObjectPreAuthNotRequired';
import { ADObjectSID } from './filters/ADObjectSID';
import { ADObjectSmartCardRequired } from './filters/ADObjectSmartCardRequired';
import { ADObjectTrustedForAuth } from './filters/ADObjectTrustedForAuth';
import { ADObjectUnconstrainedDelegation } from './filters/ADObjectUnconstrainedDelegation';

/**
 * Get simple filter definitions for ADObject entity
 * Returns filter names mapped to available values and operators
 *
 * @returns Array of filter names to SimpleFilterDefinition
 */
export function getADObjectSimpleFilters(): SimpleFilterDefinition[] {
  return [
    // AD Object specific filters - Boolean dropdowns
    ADObjectAdminCount,
    ADObjectAuthenticationEnabled,
    ADObjectPreAuthNotRequired,
    ADObjectHasSPN,
    ADObjectACLProtected,
    ADObjectIsDomainController,
    ADObjectPasswordExpired,
    ADObjectPasswordNeverExpires,
    ADObjectCannotBeDelegated,
    ADObjectSmartCardRequired,
    ADObjectTrustedForAuth,
    ADObjectUnconstrainedDelegation,

    // AD Object specific filters - Other types
    ADObjectDomain,
    ADObjectSID,
    ADObjectObjectID,

    // AD Object specific filters - Regular dropdowns
    ADObjectClass,
  ];
}
